import React from 'react';

const Greencheckmark = ({ width = '48', height = '48', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_18315_4154)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5311 1.37789C22.8796 -0.0217975 25.1208 -0.0217975 26.4693 1.37789L29.2801 4.29536L33.173 3.17416C35.0407 2.63625 36.9816 3.75683 37.4496 5.64323L38.425 9.57526L42.3573 10.5508C44.2437 11.0188 45.3641 12.9596 44.8262 14.8273L43.705 18.7203L46.6224 21.5311C48.0223 22.8796 48.0223 25.1208 46.6224 26.4693L43.705 29.2801L44.8262 33.173C45.3641 35.0409 44.2437 36.9818 42.3573 37.4498L38.425 38.4252L37.4496 42.3571C36.9816 44.2435 35.0407 45.364 33.173 44.8264L29.2801 43.7049L26.4693 46.6226C25.1208 48.0221 22.8796 48.0221 21.5311 46.6226L18.7203 43.7049L14.8273 44.8264C12.9597 45.364 11.0187 44.2435 10.5507 42.3571L9.57525 38.4252L5.64326 37.4498C3.75682 36.9818 2.63625 35.0409 3.17416 33.173L4.29538 29.2801L1.37789 26.4693C-0.021797 25.1207 -0.0217974 22.8796 1.37789 21.5311L4.29538 18.7203L3.17416 14.8273C2.63625 12.9596 3.75682 11.0188 5.64326 10.5508L9.57525 9.57526L10.5507 5.64323C11.0187 3.75683 12.9597 2.63625 14.8273 3.17416L18.7203 4.29536L21.5311 1.37789ZM34.4695 19.1781C35.3565 18.0692 35.1768 16.451 34.0678 15.5638C32.9589 14.6767 31.3407 14.8565 30.4535 15.9654L20.3533 28.5907L16.5186 25.7146C15.3825 24.8626 13.7707 25.0928 12.9186 26.2289C12.0665 27.3651 12.2967 28.9768 13.4329 29.8289L19.2614 34.2004C20.3725 35.0337 21.9446 34.8341 22.8122 33.7496L34.4695 19.1781Z"
        fill="#00C708"
      />
    </g>
    <defs>
      <clipPath id="clip0_18315_4154">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Greencheckmark;
